import { fetchStoresAroundRenderingService } from "../api/store-search-result-service";
import { customerLocality, DATA_SELECTOR_ID, STORE_SEARCH_RESULTS, storeContextTracking } from "../utils/context-layer-variables";
import { clearErrorMessage, insertErrorMessage } from "./search-errors";
import { pushStoreSearchEventsTracking } from "./tracking";
import { createCustomerContextCookie } from "../api/customer-context-cookie-service";
import { pushCustomerContextEvent } from "../../common/customer-context";
export function fetchStoresAroundRendering(storeSearchResultData, storeSearchContainer) {
  const storeSearchLoaderContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="store-search-loader"]`);
  const storeSearchResultContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_RESULTS}"]`);
  if (storeSearchLoaderContainer) storeSearchLoaderContainer.style.display = 'block';
  return new Promise((resolve, reject) => {
    fetchStoresAroundRenderingService(storeSearchResultData, resultTemplate => {
      clearErrorMessage(storeSearchContainer);
      resolve(resultTemplate);
    }, err => {
      if (storeSearchResultContainer) storeSearchResultContainer.innerHTML = '';
      insertErrorMessage(storeSearchContainer, context_layer.i18n.store_search_error);
      reject(err);
    }, () => {
      if (storeSearchLoaderContainer) storeSearchLoaderContainer.style.display = 'none';
    });
  });
}
export function integrateHtmlToStoreSearchBlock(storesResultView, storeSearchBlock) {
  const storeSearchResultBlock = storeSearchBlock.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_RESULTS}"]`);
  if (storeSearchResultBlock) storeSearchResultBlock.innerHTML = storesResultView;
}
export function applySeeMyStoreLinkTracking(storeSearchContainer, trackingFunnelName) {
  const storePageLinks = storeSearchContainer.querySelectorAll(`[${DATA_SELECTOR_ID}="store-info-link"]`);
  storePageLinks === null || storePageLinks === void 0 ? void 0 : storePageLinks.forEach(element => {
    element.addEventListener('click', function () {
      pushStoreSearchEventsTracking("see more about my store", "Contextualisation", trackingFunnelName);
    }.bind(this));
  });
}
export function initStoreContextualizationEvent(customerContext, storeSearchContainer, trackingFunnelName) {
  const chooseMyStoreButtons = storeSearchContainer.querySelectorAll(`[${DATA_SELECTOR_ID}="store-context-button"]`);
  chooseMyStoreButtons === null || chooseMyStoreButtons === void 0 ? void 0 : chooseMyStoreButtons.forEach(button => {
    button.addEventListener('click', function () {
      var _a, _b;
      const storeId = (_b = (_a = button.attributes) === null || _a === void 0 ? void 0 : _a.getNamedItem('data-store-id')) === null || _b === void 0 ? void 0 : _b.value;
      if (storeId) {
        createCustomerContextCookie(customerContext.withMainStoreId(+storeId), () => {
          pushStoreSearchEventsTracking('Choose localisation', "Contextualisation", trackingFunnelName);
          pushCustomerContextEvent();
          window.location.reload();
        });
      }
    }.bind(this));
  });
}
export function initStoreSearchResultEvents(customerContext, storeSearchContainer, storesResultView) {
  customerLocality.customerContextPostcode = customerContext.getPostcode();
  customerLocality.customerContextCity = customerContext.getCity();
  integrateHtmlToStoreSearchBlock(storesResultView, storeSearchContainer);
  applySeeMyStoreLinkTracking(storeSearchContainer, storeContextTracking.funnelName);
  initStoreContextualizationEvent(customerContext, storeSearchContainer, storeContextTracking.funnelName);
}